import type { DealProduct } from '@makemydeal/dr-platform-types';

type DraftDealProduct = Partial<DealProduct> & {
    totalPrice?: number;
};

type CalculateSummaryInput = {
    products: DraftDealProduct[];
    term?: number;
};
export function calculateVehicleProtectionSummary({ products, term }: CalculateSummaryInput) {
    const initialSummary = {
        totalProductPrice: 0,
        totalProductMarkup: 0,
        totalProductCost: 0,
        productMonthlyPayment: 0
    };

    const selectedProducts = products.filter((product) => product.selected);

    const summary = selectedProducts.reduce((summary, product) => {
        const productPrice = product.totalPrice || product.productPrice || 0;
        const productMarkup = product.productMarkup?.markupDollarAmount || 0;
        const productCost = product.productCost || 0;

        summary.totalProductPrice += productPrice;
        summary.totalProductMarkup += productMarkup;
        summary.totalProductCost += productCost;

        return summary;
    }, initialSummary);

    if (term) {
        summary.productMonthlyPayment = summary.totalProductPrice / term;
    }

    return summary;
}
export const isVppProductSelected = (product: DraftDealProduct): boolean => {
    return product.selected === true;
};
